import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { categoryService } from '../services/api';
import '../styles/Categories.css';

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await categoryService.getAllCategories();
        const categoriesData = Array.isArray(res.data) ? res.data : res.data.categories || [];
        setCategories(categoriesData);
      } catch (err) {
        console.error('Error fetching categories:', err);
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  if (loading) {
    return <div className="categories-loading">Loading categories...</div>;
  }

  return (
    <div className="categories">
      <div className="categories-header">
        <h1>Categories</h1>
        <p>Select a category to view reels</p>
      </div>
      <div className="categories-grid">
        {categories.map((category) => (
          <div
            key={category.id}
            className="category-card"
            onClick={() => navigate(`/reels/${category.id}`)}
          >
            {category.image_url && (
              <img src={category.image_url} alt={category.name} className="category-image" />
            )}
            <div className="category-overlay">
              <h3>{category.name}</h3>
              <span className="reel-count">{category.reel_count || 0} reels</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Categories;
